/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_550Inputs */

const vi_carrier_status_550 = /** @type {(inputs: Carrier_Status_550Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát tiếp`)
};

/**

* @param {Carrier_Status_550Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_550 = /** @type {((inputs?: Carrier_Status_550Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_550Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_550(inputs)
});